<template>
  <div class="step-departure-return position-relative">
    <div v-if="isViewOnly" class="protected-view" style="background: transparent"></div>
    <div class="first-session">
      <p class="title-check">{{ title }}</p>
      <table class="table-departure">
        <tr v-for="normalEq in boatNormalEquipment" :key="normalEq.boat_extra_id">
          <th style="width: 55%" class="name-add">
            {{ normalEq.name }}
          </th>
          <th style="width: 35%">
            <div class="button-change-value" v-if="!!normalEq.default_amount">
              <p class="text-intro">QTY</p>
              <div class="bar-value">
                <button @click="decreaseAmount('boat-amount-' + normalEq.boat_extra_id, normalEq.boat_extra_id)">−</button>
                <p class="text-value">{{ getExtraAmount(normalEq.boat_extra_id) }}</p>
                <input type="number"
                       :value="getExtraAmount(normalEq.boat_extra_id)"
                       :data-id="normalEq.boat_extra_id"
                       @change="updateAmount('boat-amount-' + normalEq.boat_extra_id, normalEq.boat_extra_id)"
                       class="d-none form-control extra-input-amount extra-items-tb" :id="'boat-amount-' + normalEq.boat_extra_id">
                <button @click="increaseAmount('boat-amount-' + normalEq.boat_extra_id, normalEq.boat_extra_id)">+</button>
              </div>
            </div>
            <div class="yes-no-value" v-else>
              <div class="d-flex flex-column align-items-center">
                <p class="text-intro">YES</p>
                <button class="mt-1 extra-items-yn yes" :data-id="normalEq.boat_extra_id"
                        :class="getExtraIdChoice(normalEq.boat_extra_id) ? 'active value-true' : ''" @click="changeExtraIdValue(normalEq.boat_extra_id, true)">
                  <img src="../../../assets/images/checkIcon.svg" alt="checkIcon" />
                </button>
              </div>
              <div class="d-flex flex-column align-items-center">
                <p class="text-intro">NO</p>
                <button class="mt-1 ml-2" :class="!getExtraIdChoice(normalEq.boat_extra_id) ? 'active' : ''" @click="changeExtraIdValue(normalEq.boat_extra_id, false)">
                  <img src="../../../assets/images/XIcon.png" alt="Xicon" />
                </button>
              </div>
            </div>
          </th>
          <th style="width: 10%" class="price-one" v-text="parseInt(normalEq.price) > 0 ? ('$' + normalEq.price) : ''"></th>
        </tr>

        <!-- line yes no -->
        <tr v-for="waterEq in boatWaterEquipment" :key="waterEq.boat_extra_id" :class="'list-item list-item' + waterEq.boat_extra_id">
          <th style="width: 55%" class="name-add" v-if="status === 'check_in'">
            {{waterEq.name}} {{waterEq.boat_extra_id}}
          </th>
          <th style="width: 35%">
            <div class="button-change-value" v-if="!!waterEq.default_amount">
              <p class="text-intro">QTY</p>
              <div class="bar-value">
                <button @click="decreaseAmount('boat-amount-' + waterEq.boat_extra_id, waterEq.boat_extra_id)">−</button>
                <p class="text-value">{{ getExtraAmount(waterEq.boat_extra_id) }}</p>
                <input type="number"
                       :value="getExtraAmount(waterEq.boat_extra_id)"
                       :data-id="waterEq.boat_extra_id"
                       @change="updateAmount('boat-amount-' + waterEq.boat_extra_id, waterEq.boat_extra_id)"
                       class="d-none form-control extra-input-amount extra-items-tb" :id="'boat-amount-' + waterEq.boat_extra_id">
                <button @click="increaseAmount('boat-amount-' + waterEq.boat_extra_id, waterEq.boat_extra_id)">+</button>
              </div>
            </div>
            <div class="yes-no-value" v-else>
              <div class="d-flex flex-column align-items-center">
                <p class="text-intro">YES</p>
                <button class="mt-1 extra-items-yn yes"
                        :data-id="waterEq.boat_extra_id"
                        :class="getExtraIdChoice(waterEq.boat_extra_id) ? 'active value-true' : ''" @click="changeExtraIdValue(waterEq.boat_extra_id, true)">
                  <img src="../../../assets/images/checkIcon.svg" alt="checkIcon" />
                </button>
              </div>
              <div class="d-flex flex-column align-items-center">
                <p class="text-intro">NO</p>
                <button class="mt-1 ml-2" :class="!getExtraIdChoice(waterEq.boat_extra_id) ? 'active' : ''" @click="changeExtraIdValue(waterEq.boat_extra_id, false)">
                  <img src="../../../assets/images/XIcon.png" alt="Xicon" />
                </button>
              </div>
            </div>
          </th>
          <th style="width: 10%" class="price-one" v-text="parseInt(waterEq.price) > 0 ? ('$' + waterEq.price) : ''"></th>
        </tr>

        <!-- result -->
        <!-- <tr class="result-line">
          <th>Total</th>
          <th></th>
          <th v-text="'$' + totalAmount"></th>
        </tr>-->
      </table>
    </div>

    <!-- second session -->
    <div class="second-session">
      <div class="first-list">
        <div class="select-boat">
          <img class="icon-boat-blue" src="../../../assets/images/Boat-blue.svg" alt="" />
          <div class="boat-selected position-relative">
            <p>Boat #{{ typeof checkoutBoatsList.find(boat => boat.boat_id === checkoutBoatId) !== 'undefined'
              ? checkoutBoatsList.find(boat => boat.boat_id === checkoutBoatId).display_serial : checkoutBoatId}}</p>
            <img src="../../../assets/images/down-arrow-blue.svg" alt="" />
            <select class="form-control position-absolute"
                    style="opacity: 0"
                    id="checkout-boat" v-model="checkoutBoatId">
              <option v-for="(boatList, index) in checkoutBoatsList" :key="index"
                      v-text="boatList['display_serial']" :value="boatList['boat_id']"></option>
            </select>
          </div>
        </div>

        <div class="element-options mt-5">
          <div class="title-boat-img">Boat images</div>
          <div class="col-md-12" v-if="camera.isOpen">
            <p v-if="camera.isLoading">Loading camera...</p>
            <video v-show="!camera.isLoading && !camera.isTaken" ref="camera" :width="430" :height="350" autoplay></video>
            <canvas v-show="camera.isTaken" id="photoTaken" ref="canvas" :width="430" :height="350"></canvas>
            <div class="d-flex justify-content-center">
              <a :href="DibbleJS.AnchorNoHandlerHref" class="btn-dialog ok-btn text-center" style="padding-top: 20px;" v-text="'Close Camera'" @click="toggleOpenCamera"></a>
              <a :href="DibbleJS.AnchorNoHandlerHref"
                 @click="takePhoto"
                 class="ml-2 btn-dialog ok-btn text-center"
                 style="padding-top: 20px;"
                 v-if="!camera.isLoading && !camera.isTaken" v-text="'Capture'"></a>
            </div>
          </div>
          <div v-else class="wrapper-row">
            <div class="col-md-5 col-sm-12" v-if="!definedCheckoutImagesList.length">
              <table class="table-img-upload">
                <tr>
                  <th style="width: 50%" class="name-boat-img">Image</th>
                  <th class="btn-upload-img" style="width: 30%">
                    <div class="im" style="text-align: center; padding-top: 20px;">
                      <input type="file" value="" @change="addCheckoutImage" accept="image/*" multiple />
                      <img src="../../../assets/images/Icon-upload-blue.svg" alt="" />
                    </div>
                  </th>
                  <th>
                    <div class="btn-camera" @click="toggleOpenCamera">
                      <p class="text-plus">+</p>
                      <img src="../../../assets/images/Camera-Icon-blue.svg" alt="" />
                    </div>
                  </th>
                </tr>
              </table>

              <div class="upload file-area-added" v-if="checkoutImages.length">
                <div class="row">
                  <div class="col-xl-12 col-lg-12 col-md-12 col-12">
                    <ul class="img-box product-images">
                      <li class="other-images product-image-sort" v-for="(image, index) in checkoutImages" v-bind:key="index"
                          :data-image-name="image.name"
                          :data-image-value="image.value"
                      >
                        <a :href="DibbleJS.AnchorNoHandlerHref" :class="'images-viewer images-viewer-' + index" v-viewer="{movable: false}"><img :src="image.value ? image.value : image.name" alt=""></a>
                        <a :href="DibbleJS.AnchorNoHandlerHref" @click="removeCheckoutImage(index)" class="remove-upload-image">x</a>
                      </li>
                    </ul>
                    <div class="clearfix"></div>
                  </div>
                </div>
                <div class="clearfix"></div>
              </div>
            </div>
            <div class="col-md-12" v-else>
              <table class="table-img-upload">
                <tr v-for="(imageList, index) in definedCheckoutImagesList" :key="index">
                  <th style="width: 50%" class="name-boat-img" v-text="imageList.name + (imageList.is_mandatory ? '(*)' : '')"></th>
                  <th class="btn-upload-img" style="width: 30%" v-if="typeof getCheckoutImageAdded(index) === 'undefined'">
                    <div class="im" style="text-align: center; padding-top: 20px;" @click="setCheckoutImageChangeIdx(index)">
                      <input type="file" value="" @change="addCheckoutImage" accept="image/*" multiple />
                      <img src="../../../assets/images/Icon-upload-blue.svg" alt="" />
                    </div>
                  </th>
                  <th v-if="typeof getCheckoutImageAdded(index) === 'undefined'">
                    <div class="btn-camera" @click="toggleOpenCamera">
                      <p class="text-plus">+</p>
                      <img src="../../../assets/images/Camera-Icon-blue.svg" alt="" />
                    </div>
                  </th>
                  <th style="width: 50%" v-if="typeof getCheckoutImageAdded(index) !== 'undefined'">
                    <div class="position-relative">
                      <a :href="DibbleJS.AnchorNoHandlerHref" :class="'images-viewer images-viewer-' + index" v-viewer="{movable: false}"><img style="max-width: 130px" :src="getCheckoutImageAdded(index).value ? getCheckoutImageAdded(index).value : getCheckoutImageAdded(index).name" alt=""></a>
                      <a :href="DibbleJS.AnchorNoHandlerHref" @click="removeCheckoutImage(index)" class="remove-upload-image">x</a>
                    </div>
                  </th>
                </tr>
              </table>
            </div>
          </div>
        </div>

        <div class="element-options mt-5">
          <div class="title-boat-img">Damage marking</div>
          <div class="list-marking">
            <div class="mt-3 marking-item" v-for="(marking, index) in markingLists" :key="index"
              @click="showDamageMarkingModal(marking['name'])">
              {{ marking['name'] }}
              <img src="../../../assets/images/Icon-edit-blue.svg" alt="" />
            </div>
          </div>
        </div>

        <modal-damage-marking
          v-show="isShowDialogMarking"
          :checkoutMarkingsList="status === 'check_out' ? checkoutMarkingsList : checkinMarkingsList"
          @setMarker="setDamageMarker"
          :status="status"
          @close="onCloseDamageMarkingModal"
        />
      </div>
      <div class="second-list mt-5 position-relative">
        <div v-if="isViewOnly" class="protected-view" style="background: transparent"></div>
        <div class="element-options client-signature">
          <div class="title-boat-img">
            Client signature
            <img src="../../../assets/images/Icon-edit-blue.svg" alt="" @click="clearSignature" />
          </div>
          <div class="signed-signature" v-if="signedSignature">
            <img :src="signedSignature" width="350" />
          </div>
          <div v-else class="signature-element mt-3">
            <VueSignaturePad :options="{ onBegin }" ref="signaturePad" />
          </div>

          <div class="row mt-3" v-if="status == 'check_in'">
            <div class="col-md-12">
              <div class="title-boat-img">
                Manager Code
                <img src="../../../assets/images/Icon-edit-blue.svg" alt="" @click="clearSignature" />
              </div>
              <div class="form-row mt-3">
                <div class="form-group position-relative text-note">
                  <input type="text" min="0" placeholder="" id="item-price"
                         style="background: none"
                         class="form-control" v-model="checkInManagerCode">
                  </div>
              </div>
            </div>
            <div class="col-md-12 mt-2">
              <div class="title-boat-img">
                Excess Amount
                <img src="../../../assets/images/Icon-edit-blue.svg" alt="" @click="clearSignature" />
              </div>
              <div class="form-row mt-3">
                <div class="form-group position-relative text-note">
                  <input type="number" placeholder="0" id="item-price"
                         style="background: none"
                         class="form-control" v-model="checkinExcessAmount">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mt-4 text-right" v-if="!isViewOnly">
        <button @click="performCheckout"
                :disabled="!isFilledCheckOutForm()"
                type="button" class="btn-dialog ok-btn pl-5 pr-5" style="width: auto" v-text="status === 'check_out' ? 'Checkout' : 'Checkin'"></button>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import VueSignaturePad from 'vue-signature-pad';
import $ from 'jquery';
import ImageHelper from "@/utils/Image";
import DibbleJS from "@/dibble";
import ModalDamageMarking from "@/components/Rental/OrderPage/ModalDamageMarking.vue";
import DibbleAPI from "@/api";

Vue.use(VueSignaturePad);
export default {
  name: "StepAddOnes",
  props: {
    title: String,
    boatWaterEquipment: Array,
    boatNormalEquipment: Array,
    boatExtraItems: Array,
    extraIdValuesItem: Array,
    checkoutBoatsList: Array,
    checkoutMarkingsListItems: Array,
    checkinMarkingsListItems: Array,
    boat: Object,
    definedCheckoutImagesList: {
      type: Array,
      default: () => []
    },
    orderBoatId: Number,
    status: String,
    isViewOnly: {
      type: Boolean,
      default: false
    },
    markingLists: Array,
    signedSignature: {
      type: String,
      default: ''
    },
    actionButtons: {
      type: Object,
      default: () => {}
    },
  },
  data() {
    return {
      currentStatus: '',
      DibbleJS: DibbleJS,
      boatExtras: [],
      extraIdValues: [],
      listBoatImgsData: [
        "Propeller",
        "Left side",
        "Right side",
        "Front",
        "Back",
      ],
      listMarkingDefault: ["Left", "Right", "Top"],
      isShowDialogMarking: false,
      totalAmount: 0,
      checkoutBoatId: 0,
      checkoutImageIndexChanged: 0,
      camera: {
        isOpen: false,
        isLoading: false,
        isTaken: false
      },
      clientSignature: '',
      checkoutImages: [],
      checkoutMarkingsList: [],
      checkinMarkingsList: [],
      checkInManagerCode: '',
      checkinExcessAmount: 0
    };
  },
  components: {
    ModalDamageMarking
  },
  computed: {
    isCheckinPopup() {
      return this.currentStatus === 'check_in'
    },
    isCheckInDone() {
      return this.actionButtons &&
        this.actionButtons.check_in === 'done'
    }
  },
  created() {
    this.currentStatus = this.status;
    this.checkoutBoatId = this.orderBoatId;
    this.checkoutMarkingsList = this.checkoutMarkingsListItems;
    this.checkinMarkingsList = this.checkinMarkingsListItems;
    this.extraIdValues = this.extraIdValuesItem;
    this.boatExtras = this.boatExtraItems;
  },
  methods: {
    initElements(newStatus) {
      this.currentStatus = newStatus;
      this.extraIdValues = this.extraIdValuesItem;
      this.boatExtras = this.boatExtraItems;

      if (this.extraIdValues.length) {
        for (const i in this.extraIdValues) {
          if (typeof this.extraIdValues[i].value === 'boolean') {
            this.extraIdValues[i].value = false
          } else {
            this.extraIdValues[i].value = ''
          }
        }
      }

      if (this.boatExtras.length) {
        for (const i in this.boatExtras) {
          const extraIdx = this.extraIdValues.findIndex(extraItem => extraItem.id === this.boatExtras[i].boat_extra_id)
          if (typeof extraIdx != 'undefined' && extraIdx >= 0) {
            let amount
            if (this.currentStatus === 'check_out') {
              amount = this.boatExtras[i].amount_checkout
            } else {
              if (this.isCheckinPopup && !this.isCheckInDone) {
                amount = this.boatExtras[i].amount_checkout
              } else {
                amount = this.boatExtras[i].amount_checkin
              }
            }

            this.extraIdValues[extraIdx].value = amount
          }
        }
      }
    },
    onBegin() {
      this.$refs.signaturePad.resizeCanvas();
    },
    clearSignature() {
      this.$refs.signaturePad.clearSignature();
    },
    saveSignature() {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
      if (!isEmpty) {
        this.clientSignature = data;
      }

      return isEmpty;
    },
    getExtraAmount(extraId) {
      const item = this.boatExtras.find(extra => extra.boat_extra_id === extraId);
      if (typeof item != 'undefined') {
        if (this.isCheckinPopup && this.isCheckInDone) {
          return item.amount_checkin
        } else {
          return item.amount_checkout
        }
      } else {
        return 0
      }
    },
    updateAmount(elementId, extraId) {
      const index = this.boatExtras.findIndex(item => item.boat_extra_id === extraId);
      let value = $('#' + elementId).val()
      if (value.trim() === '') {
        value = 0
        $('#' + elementId).val(0)
      }
      if (typeof index != 'undefined' && index >= 0) {
        if (this.currentStatus === 'check_out') {
          this.boatExtras[index].amount_checkout = value;
        } else {
          this.boatExtras[index].amount_checkin = value;
        }
      } else {
        if (this.currentStatus === 'check_out') {
          this.boatExtras.push({
            boat_extra_id: extraId,
            amount_checkout: value
          })
        } else {
          this.boatExtras.push({
            boat_extra_id: extraId,
            amount_checkin: value
          })
        }
      }
      this.getTotalAmount();
    },
    decreaseAmount(elementId, extraId) {
      const index = this.boatExtras.findIndex(item => item.boat_extra_id === extraId);
      const jElement = $('#' + elementId)
      let currentValue = parseInt(jElement.val());

      if (currentValue > 0) {
        currentValue -= 1
        jElement.val(currentValue);

        if (typeof index != 'undefined' && index >= 0) {
          if (this.currentStatus === 'check_out') {
            this.boatExtras[index].amount_checkout = currentValue;
          } else {
            this.boatExtras[index].amount_checkin = currentValue;
          }
        } else {
          if (this.currentStatus === 'check_out') {
            this.boatExtras.push({
              boat_extra_id: extraId,
              amount_checkout: currentValue
            })
          } else {
            this.boatExtras.push({
              boat_extra_id: extraId,
              amount_checkin: currentValue
            })
          }
        }
      }
      this.getTotalAmount();
    },
    increaseAmount(elementId, extraId) {
      const index = this.boatExtras.findIndex(item => item.boat_extra_id === extraId);
      const jElement = $('#' + elementId)
      let currentValue = parseInt(jElement.val()) + 1;
      jElement.val(currentValue);
      if (typeof index != 'undefined' && index >= 0) {
        if (this.currentStatus === 'check_out') {
          this.boatExtras[index].amount_checkout = currentValue;
        } else {
          this.boatExtras[index].amount_checkin = currentValue;
        }
      } else {
        if (this.currentStatus === 'check_out') {
          this.boatExtras.push({
            boat_extra_id: extraId,
            amount_checkout: currentValue
          })
        } else {
          this.boatExtras.push({
            boat_extra_id: extraId,
            amount_checkin: currentValue
          })
        }
      }
      this.getTotalAmount();
    },
    changeExtraIdValue(extraId, value) {
      const index = this.boatExtras.findIndex(extra => extra.boat_extra_id === extraId);
      if (index >= 0) {
        if (this.currentStatus === 'check_out') {
          this.boatExtras[index].amount_checkout = value;
        } else {
          this.boatExtras[index].amount_checkin = value;
        }
      } else {
        if (this.currentStatus === 'check_out') {
          this.boatExtras.push({
            boat_extra_id: extraId,
            amount_checkout: value
          })
        } else {
          this.boatExtras.push({
            boat_extra_id: extraId,
            amount_checkin: value
          })
        }
      }

      const index2 = this.extraIdValues.findIndex(extra => extra.id === extraId);
      if (index2 >= 0) {
        this.extraIdValues[index2].value = value
      }

      this.formDirty = true
    },
    getExtraIdChoice(extraId) {
      const item = this.extraIdValues.find(extra => extra.id === extraId);
      if (typeof item != 'undefined') {
        return item.value
      } else {
        return false
      }
    },
    getTotalAmount() {
      let total = 0
      for (const i in this.boatExtras) {
        if (this.boatExtras[i].default_amount) {
          const amount = this.currentStatus === 'check_out' ? this.boatExtras[i].amount_checkout : this.boatExtras[i].amount_checkin
          total += amount ? (parseInt(amount) * this.boatExtras[i].price) : 0
        } else if (this.boatExtras[i].amount) {
          total += parseInt(this.boatExtras[i].price)
        }
      }

      this.totalAmount = total
    },
    toggleOpenCamera() {
      if(this.camera.isOpen) {
        this.camera.isOpen = false;
        this.camera.isTaken = false
        this.stopCameraStream();
      } else {
        this.camera.isOpen = true;
        this.createCameraElement();
      }
    },
    createCameraElement() {
      this.camera.isLoading = true;
      if (typeof navigator.mediaDevices != 'undefined') {
        navigator.mediaDevices
          // .getUserMedia({video: { facingMode: { exact: "environment" } }})
          .getUserMedia({video: { facingMode: "environment" } })
          .then(stream => {
            this.camera.isLoading = false;
            this.$refs.camera.srcObject = stream;
          })
          .catch(error => {
            console.log(error)
            this.camera.isLoading = false;
            this.camera.isOpen = false;
            alert("This browser is not support camera1.");
          });
      } else {
        this.camera.isOpen = false;
        this.camera.isLoading = false;
        alert("This browser is not support camera.");
      }
    },
    removeCheckoutImage(index) {
      if (this.checkoutImages.length > 1) {
        if (this.definedCheckoutImagesList.length) {
          this.checkoutImages = this.checkoutImages.filter(image => image.index !== index);
        } else {
          this.checkoutImages = this.checkoutImages.filter((image, idx) => idx !== index);
        }
      } else {
        this.checkoutImages = [];
      }
    },
    getCheckoutImageAdded(idx) {
      return this.checkoutImages.find(item => item.index === idx)
    },
    setCheckoutImageChangeIdx(idx) {
      this.checkoutImageIndexChanged = idx
    },
    show (index) {
      const viewer = this.$el.querySelector('.images-viewer-' + index).$viewer
      viewer.show()
    },
    stopCameraStream() {
      let tracks = this.$refs.camera.srcObject.getTracks();

      tracks.forEach(track => {
        track.stop();
      });
    },
    takePhoto() {
      this.camera.isTaken = !this.camera.isTaken;
      const context = this.$refs.canvas.getContext('2d');
      context.drawImage(this.$refs.camera, 0, 0, 430, 350);

      const canvas = document.getElementById("photoTaken").toDataURL("image/jpeg")
        .replace("image/jpeg", "image/octet-stream");

      let image = {}
      if (this.definedCheckoutImagesList.length) {
        const addedImage = this.checkoutImages.find(item => item.index === this.checkoutImageIndexChanged)
        image = typeof addedImage != 'undefined'
          ? addedImage
          : {index: this.checkoutImageIndexChanged};
      }
      image.name = "";
      image.value = canvas;
      this.toggleOpenCamera()
      this.checkoutImages.push(image);
    },
    addCheckoutImage (input) {
      const files = input.target.files;
      if (files && files.length > 0) {
        for (let i = 0;i < files.length;i++) {
          const reader = new FileReader();
          const file = files[i];
          if (file.type.indexOf('image') < 0) {
            DibbleJS.toastErrorMessage("Invalid image type.");
            return false;
          }

          let image = {}
          if (this.definedCheckoutImagesList.length) {
            const addedImage = this.checkoutImages.find(item => item.index === this.checkoutImageIndexChanged)
            image = typeof addedImage != 'undefined'
              ? addedImage
              : {index: this.checkoutImageIndexChanged};
          }
          image.name = file.name;

          reader.onload = (e) => {
            console.log(e);
          };

          reader.readAsDataURL(files[i]);

          ImageHelper.resizeImage({ file: files[i], maxSize: 1200 }).then((resizedImage) => {
            const newReader = new FileReader();
            newReader.readAsDataURL(resizedImage);
            newReader.onloadend = () => {
              image.value = newReader.result;
              this.checkoutImages.push(image);
            }
          }).catch((err) => {
            console.error(err);
          });
        }
      }
      this.formDirty = true
    },
    showDamageMarkingModal(image) {
      this.$emit('setCurrentMarkerImage', {
        image: image,
        status: this.currentUpdateStatus
      });
      this.isShowDialogMarking = true;
    },
    setDamageMarker(data) {
      if (this.currentStatus === 'check_out') {
        const idx = this.checkoutMarkingsList.findIndex(item => item['image_url'] === data['image'])
        if (idx >= 0) {
          this.checkoutMarkingsList[idx]['markers'] = data['markers']
          this.checkoutMarkingsList[idx]['display_image_width'] = data['display_image_width']
        }
      } else {
        const idx = this.checkinMarkingsList.findIndex(item => item['image_url'] === data['image'])
        if (idx >= 0) {
          this.checkinMarkingsList[idx]['markers'] = data['markers']
          this.checkinMarkingsList[idx]['display_image_width'] = data['display_image_width']
        }
      }
    },
    onCloseDamageMarkingModal() {
      this.isShowDialogMarking = false
    },
    performCheckout() {
      const isEmptySignatureSet = this.saveSignature();
      if (isEmptySignatureSet) {
        DibbleJS.toastErrorMessage('Please draw your signature');
        return;
      }

      if (this._validateCheckoutData()) {
        const params = {
          request: this.currentStatus === 'check_out'
            ? DibbleAPI.api.checkoutRentalBoat
            : DibbleAPI.api.checkinRentalBoat,
          boat_extras: [],
          images: [],
          markings: [],
          client_signature: this.clientSignature,
          order_id: this.orderId,
          damage_description: this.damageMakingNotes
        };
        if (this.currentStatus === 'check_out') {
          params['actual_boat_id'] = this.checkoutBoatId
        }

        const me = this
        $('.extra-items-tb').each(function(){
          if (me.status === 'check_out') {
            params.boat_extras.push({
              boat_extra_id: $(this).data('id'),
              amount_checkout: $(this).val()
            })
          } else {
            params.boat_extras.push({
              boat_extra_id: $(this).data('id'),
              amount_checkin: $(this).val()
            })
          }
        })

        $('.extra-items-yn.yes.value-true').each(function(){
          if (me.status === 'check_out') {
            params.boat_extras.push({
              boat_extra_id: $(this).data('id'),
              amount_checkout: 1
            })
          } else {
            params.boat_extras.push({
              boat_extra_id: $(this).data('id'),
              amount_checkin: 1
            })
          }
        })

        if (!this.validateCheckoutImageMandatory()) {
          DibbleJS.toastErrorMessage('Please upload all mandatory images marked as *');
          return
        }

        this.checkoutImages.forEach(image => {
          params.images.push({image: image.value})
        })

        let needValidateCheckinManagerCode = false
        if (this.currentStatus === 'check_out' && this.checkoutMarkingsList) {
          this.checkoutMarkingsList.forEach(item => {
            const marker = {
              name: item['name'],
              image_url: item['image_url'],
              display_image_width: typeof item['display_image_width'] !== 'undefined' ? item['display_image_width'] : 0,
              marks: []
            }
            if (item['markers'].length) {
              item['markers'].forEach(markerItem => {
                marker.marks.push(`${markerItem['x']},${markerItem['y']}`)
              })
              marker.marks = marker.marks.join(';')
            }
            params.markings.push(marker)
          })
        } else if (this.currentStatus === 'check_in' && this.checkinMarkingsList) {
          this.checkinMarkingsList.forEach(item => {
            const marker = {
              name: item['name'],
              image_url: item['image_url'],
              display_image_width: typeof item['display_image_width'] !== 'undefined' ? item['display_image_width'] : 0,
              marks: []
            }
            if (item['markers'].length) {
              item['markers'].forEach(markerItem => {
                marker.marks.push(`${markerItem['x']},${markerItem['y']}`)
              })
              marker.marks = marker.marks.join(';')
              needValidateCheckinManagerCode = true
            }
            params.markings.push(marker)
          })
        }

        if (needValidateCheckinManagerCode && (!this.checkInManagerCode || !this.checkinExcessAmount)) {
          DibbleJS.toastErrorMessage("Please fill the manager code and set the excess amount")
          return
        } else {
          params['admin_passcode'] = this.checkInManagerCode
          params['damage_excess'] = this.checkinExcessAmount
        }

        DibbleJS.showLoader();
        params.order_id = this.$route.params.id
        params.boat_id = this.orderBoatId

        DibbleJS.callApiRequest(params, (response) => {
          DibbleJS.hideLoader();
          if (DibbleAPI.isResponseSuccess(response)) {
            DibbleJS.toastSuccessMessage(response.message)
            this.$emit('reload')
          } else {
            DibbleJS.toastErrorMessage(response.message)
          }
        })
      }
    },
    validateCheckoutImageMandatory() {
      let isPassed = true
      if (this.actionButtonStatus === 'done') {
        return isPassed
      }

      for (const i in this.definedCheckoutImagesList) {
        if (this.definedCheckoutImagesList[i].is_mandatory) {
          const imageAdded = this.checkoutImages.find(item => item.index == i)
          if (typeof imageAdded === 'undefined') {
            isPassed = false
            break
          }
        }
      }

      return isPassed
    },
    _validateCheckoutData() {
      let validated = true

      if (this.currentStatus === 'check_in') {
        return validated
      }

      if (this.boatExtras.length) {
        const extraAdults = this.extraIdValues.find(item => item.type === 'adults')
        const extraChildren = this.extraIdValues.find(item => item.type === 'children')
        const extraPets = this.extraIdValues.find(item => item.type === 'pets')
        const extraLifeJackets = this.extraIdValues.find(item => item.type === 'life_jackets')

        const amountAdults = typeof extraAdults !== 'undefined'
          ? (typeof this.boatExtras.find(item => item.boat_extra_id === extraAdults.id) !== 'undefined' ? parseInt(this.boatExtras.find(item => item.boat_extra_id === extraAdults.id).amount_checkout) : 0)
          : 0

        const amountChildren = typeof extraChildren !== 'undefined'
          ? (typeof this.boatExtras.find(item => item.boat_extra_id === extraChildren.id) !== 'undefined' ? parseInt(this.boatExtras.find(item => item.boat_extra_id === extraChildren.id).amount_checkout) : 0)
          : 0

        const amountPets = typeof extraPets !== 'undefined'
          ? (typeof this.boatExtras.find(item => item.boat_extra_id === extraPets.id) !== 'undefined' ? parseInt(this.boatExtras.find(item => item.boat_extra_id === extraPets.id).amount_checkout) : 0)
          : 0

        if (typeof extraLifeJackets !== 'undefined') {
          const amountLifeJackets = this.boatExtras.find(item => item.boat_extra_id === extraLifeJackets.id)
          if (typeof amountLifeJackets !== 'undefined') {
            if (parseInt(amountLifeJackets.amount_checkout) < (amountAdults + amountChildren)) {
              DibbleJS.toastErrorMessage('There are not enough life jackets for everyone')
              validated = false
            }
          }
        }

        if (validated) {
          if ((amountAdults + amountChildren + amountPets) > this.boat.num_of_people) {
            DibbleJS.toastErrorMessage('There are too many people for this boat')
            validated = false
          }
        }

        if (validated) {
          const extraPropeller = this.extraIdValues.find(item => item.type === 'propeller')
          if (typeof extraPropeller !== 'undefined') {
            const propellerValue = typeof this.boatExtras.find(item => item.boat_extra_id === extraPropeller.id) !== 'undefined'
              ? this.boatExtras.find(item => item.boat_extra_id === extraPropeller.id).amount_checkout
              : false

            if (!propellerValue) {
              DibbleJS.toastErrorMessage('There propeller must be in good condition')
              validated = false
            }
          }
        }
      }

      return validated
    },
    isFilledCheckOutForm() {
      let isPassed = true
      this.extraIdValues.forEach(extraItem => {
        if (isPassed && typeof extraItem.value !== 'boolean') {
          const addedItem = this.boatExtras.find(item => item.boat_extra_id === extraItem.id)
          if (typeof addedItem === 'undefined') {
            isPassed = false
          }
        }
      })

      return isPassed
    },
  },
};
</script>

<style lang="scss" scoped>
.step-departure-return {
  height: auto;
  width: 100%;
  user-select: none;
  display: flex;
}

.first-session {
  width: 60%;
}

.second-session {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: space-around;

  .first-list {
    height: auto;
  }

  .second-list {
    flex: 1;
    margin-bottom: 0;
    display: flex;
    align-items: flex-end;
    padding-bottom: 45px;
  }

  .select-boat {
    display: flex;
    flex-direction: column;
    width: 300px;
    height: 63px;
    background: #c2d8dd;
    box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
    border-radius: 40px;
    padding: 15px 20px;
    box-sizing: border-box;
    position: relative;

    .icon-boat-blue {
      width: 35px;
    }

    .boat-selected {
      display: flex;
      justify-content: space-between;

      p {
        font-family: "Roboto";
        font-style: normal;
        font-weight: 500;
        font-size: 18px;
        line-height: 24px;
        color: #1c5169;
        padding-top: 2px;
      }
    }
  }

  .element-options {
    padding: 15px 20px;
    height: auto;
    background: #e8eff1;
    border-radius: 40px;
    box-sizing: border-box;

    .title-boat-img {
      display: flex;
      justify-content: space-between;
      font-family: "Open Sans";
      font-style: normal;
      font-weight: 700;
      font-size: 20px;
      color: #1c5169;
      letter-spacing: 0.04em;
      border-bottom: 1.5px solid #1c5169;
      padding: 5px 0px;
    }

    .name-boat-img {
      font-family: "Open Sans";
      font-style: normal;
      font-weight: 400;
      font-size: 20px;
      line-height: 22px;
      color: #555e67;
    }

    .btn-camera {
      display: flex;
      cursor: pointer;
    }

    .text-plus {
      font-size: 20px;
      user-select: none;
      color: #2c94ab;
      padding-right: 3px;
    }

    .table-img-upload {
      width: 100%;

      tr {
        user-select: none;
        border: none;
      }

      th {
        padding-top: 20px;
        user-select: none;
      }
    }

    .btn-upload-img {
      cursor: pointer;
    }

    .marking-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      box-sizing: border-box;
      padding: 10px 15px;
      background: #c2d8dd;
      box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
      border-radius: 30px;
      width: 130px;
      font-family: "Open Sans";
      font-style: normal;
      font-weight: 600;
      font-size: 20px;
      text-align: center;
      color: #555e67;
      cursor: pointer;
    }
  }

  .client-signature {
    width: 300px;
    background: #c2d8dd;
    height: max-content;
  }

  .signature-element {
    height: 150px;
    width: 100%;
    background: #e8eff1;
    box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
    border-radius: 30px;
  }
}

.title-check {
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 600;
  font-size: 22px;
  line-height: 40px;
  color: #1c5169;
}

.table-departure {
  width: 100%;
  user-select: none;

  tr {
    &:last-child {
      border-bottom: none;
    }

    &:nth-last-child(2) {
      border-bottom: 1.5px solid #2c94ab;
    }

    user-select: none;
    border-bottom: 1.5px solid #dee6ea;
  }

  th {
    padding-top: 20px;
    user-select: none;
  }

  .name-add {
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 24px;
    color: #555e67;
  }

  .button-change-value {
    display: flex;
    flex-direction: column;
    width: max-content;
    align-items: center;
    margin-bottom: 25px;
  }

  .text-intro {
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 19px;
    display: flex;
    text-align: center;
    letter-spacing: 0.08em;
    color: #7c7c7a;
  }

  .bar-value {
    display: flex;
    align-items: center;
    justify-content: space-around;
    width: 130px;
    height: 40px;
    background: #1c5169;
    box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
    border-radius: 40px;
    margin-top: 10px;

    button {
      border: none;
      outline: none;
      color: #fff;
      font-size: 30px;
      background: initial;
    }

    .text-value {
      font-family: "Open Sans";
      font-style: normal;
      font-weight: 600;
      font-size: 30px;
      line-height: 24px;
      color: #ffffff;
    }
  }

  .yes-no-value {
    width: 130px;
    display: flex;
    margin-bottom: 25px;

    .active {
      background: #1c5169;
    }

    button {
      border: none;
      outline: none;
      background: #d9d9d9;
      box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
      border-radius: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 61px;
      height: 47px;
    }
  }

  .price-one {
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 24px;
    color: #555e67;
  }

  .actions {
    img {
      cursor: pointer;
    }
  }

  .result-line {
    th {
      font-family: "Open Sans";
      font-style: normal;
      font-weight: 600;
      font-size: 20px;
      line-height: 24px;
      color: #2c94ab;
    }
  }
}

.btn-dialog {
  width: 250px;
  height: 60px;
  background: #d9d9d9;
  box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 18px;
  text-align: space-between;
  color: #ffffff;
  border: none;
}

.ok-btn {
  background: #2178ab;
  color: #ffffff;
}
.protected-view {
  position: absolute;
  width: 100%;
  height: 100%;
  background: #fff;
  z-index: 9990;
  opacity: 0.4;
}
</style>
